"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetGroupsResponse () {
        return GetGroupsResponse;
    },
    get GroupItem () {
        return GroupItem;
    }
});
const _zod = require("zod");
const GroupItem = _zod.z.object({
    id: _zod.z.string(),
    name: _zod.z.string()
});
const GetGroupsResponse = _zod.z.object({
    data: _zod.z.array(GroupItem),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
